const normalise = (oldText, specList) => {
  if (!specList || specList.length === 0) return oldText
  const fromIndex = 0
  const uptoIndex = oldText.indexOf('Overview:')
  const newText = oldText.slice(fromIndex, uptoIndex)
  return newText
}

export default normalise
